import React, { useState, useEffect } from "react";
import { IFisco } from "../../interfaces/IFisco";
import { Modal } from 'react-bootstrap-v5';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import clsx from "clsx";
import './styleDualListBox.css';
import 'react-dual-listbox/lib/react-dual-listbox.css';
import GrupoEventoService from "../../services/GrupoEventoService";
import { IFiscoEvento } from "../../interfaces/IFiscoEvento";
import FiscoEventoTabela from "./FiscoEventoTabela";
import EventoService from "../../services/EventoService";
import CalendarioService from "../../services/CalendarioService.";
import ICalendario from "../../interfaces/ICalendario";
import FiscoEventoService from "../../services/FiscoEventoService";
import Swal from "sweetalert2";
import { LISTA_ESTADOS } from "../../utils/Constants";
import { IEvento } from "../../interfaces/IEvento";
import { IGrupoEvento } from "../../interfaces/IGrupoEvento";

const DualListBox = require('react-dual-listbox');

interface option {
    value: string;
    label: string;
};

interface tipoFisco {
    id: number;
    texto: string;
};

function FiscoModal({ toggleModal, salvar, show, fisco, title }: { toggleModal: () => void, salvar: (fisco: IFisco) => void, show: boolean, fisco: IFisco, title: string }) {
    
    const [selected, setSelected] = useState<any[]>([]);
    const [abaSelecionada, setAbaSelecionada] = useState<number>(1);
    const [carregadoEventos, setCarregadoEventos] = useState<boolean>(false);
    const [carregadoCalendario, setCarregadoCalendario] = useState<boolean>(false);
    const [carregadoGruposEvento, setCarregadoGruposEvento] = useState<boolean>(false);
    const [fiscoEventos, setFiscoEventos] = useState<IFiscoEvento[]>([]);
    const [fiscoEventoNovo, setFiscoEventoNovo] = useState<IFiscoEvento>({} as IFiscoEvento);
    const [calendarios, setCalendarios] = useState<ICalendario[]>([]);
    const [grupoEvento, setGrupoEvento] = useState<IGrupoEvento[]>([]);
    const [grupoEventoSelecionado, setGrupoEventoSelecionado] = useState<number>(-1);
    const [eventos, setEventos] = useState<IEvento[]>([]);
    const [eventosFiltrados, setEventosFiltrados] = useState<IEvento[]>([]);
    const vencimento = [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31
    ];
    const tiposFisco: tipoFisco[] = [
        { id: 1, texto: 'Federal' },
        { id: 2, texto: 'Estadual' },
        { id: 3, texto: 'Municipal' }
    ];
    const columns = [
        {
            name: 'Evento',
            selector: (row: IFiscoEvento) => row['evento']['nome'],
            sortable: true
        },
        {
            name: 'Vencimento',
            selector: (row: IFiscoEvento) => row['vencimento'],
            sortable: true
        },
        {
            name: 'Alíquota %',
            selector: (row: IFiscoEvento) => `${row['aliquota']} %`,
            sortable: true
        },
        {
            name: 'Regra do tributário',
            selector: (row: IFiscoEvento) => row['tipoRegraTributoID'] === 1 ?  'Próximo dia útil' : 'Dia útil anterior',
            sortable: true
        },
        {
            name: 'Ação',
            cell: (row: IFiscoEvento) => <AcoesFisco excluirFiscoEvento={excluirFiscoEvento} item={row} />
        }
    ];
    const options: option[] = calendarios.map(x => ({ value: x.id!.toString(), label: x.nomeCalendario! }));
    const fiscosSchema = Yup.object().shape({
        nome: Yup.string().required('Nome é obrigatório'),
        estado: Yup.string().test('validacao-estado', 'Estado é obrigatório', value => {
            if (formikFisco.values.tipoFisco === 0 || formikFisco.values.tipoFisco === 1 || value) {
                return true;
            }

            return false;
        }),
        municipio: Yup.string().test('validacao-municipio', 'Município é obrigatório', value => {
            if (formikFisco.values.tipoFisco === 0 || formikFisco.values.tipoFisco === 1 || formikFisco.values.tipoFisco === 2 || value) {
                return true;
            }

            return false;
        }),
        tipoFisco: Yup.string().required('Tipo do Fisco é obrigatório')
    });
    const formInitialValuesFisco = {
        id: 0,
        nome: '',
        estado: '',
        tipoFisco: 0,
        tipoEvento: '',
        municipio: '',
        fiscoCalendarios: [],
        fiscoEventos: []
    } as IFisco;
    const formikFisco = useFormik({
        initialValues: formInitialValuesFisco,
        validationSchema: fiscosSchema,
        onSubmit: (values, { setSubmitting }) => {
            if (values.tipoFisco === 1) {
                values.estado = '';
                values.municipio = '';
            }
            else if (values.tipoFisco === 2) {
                values.municipio = '';
            }

            values.fiscoEventos = fiscoEventos;

            salvar(values);
            setSubmitting(false);
        }
    });
    const fiscoEventoSchema = Yup.object().shape({
        evento: Yup.object().required('Evento é obrigatório'),
        eventoID: Yup.number().required('EventoId é obrigatório').moreThan(0),
        aliquota: Yup.number().required('Alíquota é obrigatório'),
        vencimento: Yup.number().required('Vencimento é obrigatório').moreThan(0),
        tipoRegraTributoID: Yup.number().required('Tipo da Regra de Tributo é obrigatório').moreThan(0)
      });
    const formInitialValuesFiscoEvento: IFiscoEvento = {
        fiscoID: 0,
        eventoID: 0,
        aliquota: 0,
        vencimento: 0,
        tipoRegraTributoID: 0,
        evento: {} as IEvento
    };
    const formikFiscoEvento = useFormik({
        initialValues: formInitialValuesFiscoEvento,
        validationSchema: fiscoEventoSchema,
        onSubmit: async (values, { setSubmitting }) => {
            const valorInicial = {...formInitialValuesFiscoEvento, fiscoID: fisco.id };
            setGrupoEventoSelecionado(0);
            setEventosFiltrados(eventos);
            setFiscoEventoNovo(valorInicial);
            formikFiscoEvento.setValues(valorInicial);
            setFiscoEventos([...fiscoEventos, values]);
            setSubmitting(false);
        }
    });

    useEffect(() => {
        if (fisco && fisco.id) {
            fisco.tipoFisco = fisco.municipio && fisco.estado ? 3 : fisco.municipio ? 2 : fisco.nome ? 1 : 0;
            if (fisco.tipoFisco === 1) {
                formikFisco.setFieldTouched('nome', true);
                formikFisco.setFieldTouched('tipoFisco', true);
                formikFisco.setFieldTouched('estado', false);
                formikFisco.setFieldTouched('municipio', false);
            } else if (fisco.tipoFisco === 2) {
                formikFisco.setFieldTouched('nome', true);
                formikFisco.setFieldTouched('tipoFisco', true);
                formikFisco.setFieldTouched('estado', true);
                formikFisco.setFieldTouched('municipio', false);
            } else {
                formikFisco.setFieldTouched('tipoFisco', true);
                formikFisco.setFieldTouched('municipio', true);
                formikFisco.setFieldTouched('estado', true);
                formikFisco.setFieldTouched('nome', true);
            }
            
            formikFisco.setValues(fisco);
        }

        const valorInicial = {...formInitialValuesFiscoEvento, fiscoID: fisco.id };

        setFiscoEventoNovo(valorInicial);
        formikFiscoEvento.setValues(valorInicial);
        !fiscoEventoNovo.evento && formikFiscoEvento.setFieldTouched('evento', false);
        !fiscoEventoNovo.eventoID && formikFiscoEvento.setFieldTouched('eventoID', false);
        !fiscoEventoNovo.aliquota && formikFiscoEvento.setFieldTouched('aliquota', false);
        !fiscoEventoNovo.vencimento && formikFiscoEvento.setFieldTouched('vencimento', false);
        !fiscoEventoNovo.tipoRegraTributoID && formikFiscoEvento.setFieldTouched('tipoRegraTributoID', false);

        inicializar(fisco);

        // eslint-disable-next-line
    }, [fisco]);

    useEffect(() => {
        document.querySelectorAll(".rdl-control, .rdl-move").forEach(x => carregadoCalendario ? x.removeAttribute("disabled") : x.setAttribute("disabled","disabled"));

    }, [carregadoCalendario])

    async function inicializar(fisco: IFisco) {
        setGrupoEventoSelecionado(-1);
        setCarregadoEventos(false);
        setCarregadoCalendario(false);
        setCarregadoGruposEvento(false);
        setFiscoEventos(fisco.fiscoEventos ?? []);
        setSelected(fisco.fiscoCalendarios?.map(x => x.calendarioID.toString()));

        setCalendarios(await CalendarioService.obterTodos());
        setCarregadoCalendario(true);
        setGrupoEvento((await GrupoEventoService.obterTodos()).sort((a, b) => a.id > b.id ? 1 : -1));
        setCarregadoGruposEvento(true);
        await EventoService.obterTodos(x => setEventos(x));
        setCarregadoEventos(true);
        setGrupoEventoSelecionado(0);
        setEventosFiltrados(eventos);
    }
    
    async function onChange(itens: any[]) {
        setSelected(itens);
        await formikFisco.setFieldValue('fiscoCalendarios', itens.map(x => ({
            fiscoID: fisco.id,
            calendarioID: x
        })));
    }
    
    function BotoesHeaderTabela() {
        const opcoesFiltros = [
            { id: 1, descricao: 'Dados Fisco' },
            { id: 2, descricao: 'Eventos' }
        ];

        return <>
            {
                opcoesFiltros.map((x, index) => <button key={index} type="submit" className={`btn btn-filtro ${x.id === abaSelecionada && 'ativo'}`} onClick={() => setAbaSelecionada(x.id)}>{x.descricao}</button>)
            }
        </>
    };

    function AcoesFisco({ item, excluirFiscoEvento }: { item: IFiscoEvento, excluirFiscoEvento: (fiscoEvento: IFiscoEvento) => void }) {
        return <div data-tag="allowRowEvents">
            <i onClick={() => excluirFiscoEvento(item)} className="fas fa-trash-alt fs-1" style={{ color: '#5E6397', marginLeft: '20px', fontWeight: 'normal', cursor: 'pointer' }}/>
        </div>
    }
    
    async function excluirFiscoEvento(item: IFiscoEvento) {
        try {
            if (fisco.id !== 0 && fisco.id !== null && fisco.id !== undefined) {
                await FiscoEventoService.excluir(fisco.id, item.eventoID);
                setFiscoEventos(await FiscoEventoService.obterPorId(fisco.id));
            } else {
                let array = fiscoEventos;

                array = array.splice(array.indexOf(array.find(x => x.eventoID === item.eventoID)!), 1);
                setFiscoEventos(array);
            }

            await Swal.fire({
                text: 'O evento foi removido do fisco com sucesso',
                timer: 4000,
                icon: 'success',
                showConfirmButton: false
            });
        } catch (error: any) {
            Swal.fire({
                text: error.message,
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
        }
    }

    console.log(formikFisco)

    return <Modal size='xl' centered={true} show={show} onHide={() => toggleModal()}>
        <div className="modal-content">
            <div className="modal-header">
                <h5 className="modal-title titulo-modal">{ title }</h5>
                <button onClick={() => toggleModal()} className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                    <i className="fas fa-times" style={{ color: '#5E6397' }}/>
                </button>
            </div>
            <div className="modal-body" style={{ padding: '10px', minHeight: '500px' }}>
                <BotoesHeaderTabela />
                {
                    abaSelecionada === 1 ? 
                        <div className="row g-3">
                            <div className="col-md-12">
                                <label htmlFor="form-fisco-nome" className="form-label required mt-5">Nome do Fisco</label>
                                <input placeholder="Digite algo" type="text" {...formikFisco.getFieldProps('nome')} className={clsx(
                                    'form-control',
                                    {
                                        'is-invalid': formikFisco.touched.nome && formikFisco.errors.nome
                                    },
                                    {
                                        'is-valid': formikFisco.touched.nome && !formikFisco.errors.nome
                                    }
                                )} id="form-fisco-nome" />
                            </div>
                            <div className="col-md-3">
                                <label htmlFor="form-fisco-tipo-fisco" className="form-label required mt-5">Tipo do Fisco</label>
                                <select id="form-fiso-tipo-fisco" {...formikFisco.getFieldProps('tipoFisco')} 
                                    onChange={async e => await formikFisco.setFieldValue('tipoFisco', parseInt(e.target.value))} className={clsx(
                                        'form-select',
                                        {
                                            'is-invalid': formikFisco.touched.tipoFisco && (formikFisco.errors.tipoFisco || formikFisco.values.tipoFisco === 0)
                                        },
                                        {
                                            'is-valid': formikFisco.touched.tipoFisco && !formikFisco.errors.tipoFisco && formikFisco.values.tipoFisco !== 0
                                        }
                                        )}>

                                    <option value="" hidden>Selecione</option>
                                    {
                                        tiposFisco.map((x, index) => <option key={index} value={x.id}>{x.texto}</option>)
                                    }
                                </select>
                            </div>
                            <div className="col-md-3">
                                <label htmlFor="form-fisco-estado" className="form-label required mt-5">Estado (UF)</label>
                                <select id="form-fisco-estado" disabled={formikFisco.values.tipoFisco === 0 || formikFisco.values.tipoFisco === 1} {...formikFisco.getFieldProps('estado')} 
                                    onChange={async e => await formikFisco.setFieldValue('estado', e.target.value)} className={clsx(
                                        'form-select',
                                        {
                                            'is-invalid': formikFisco.touched.estado && formikFisco.errors.estado
                                        },
                                        {
                                            'is-valid': formikFisco.touched.estado && !formikFisco.errors.estado
                                        }
                                    )}>

                                    <option value="" hidden>Selecione</option>
                                    {
                                        LISTA_ESTADOS.map((x, index) => <option key={index} value={x}>{x}</option>)
                                    }
                                </select>
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="form-fisco-municipio" className="form-label required mt-5">Munícipio</label>
                                <input disabled={formikFisco.values.tipoFisco === 0 || formikFisco.values.tipoFisco === 1 || formikFisco.values.tipoFisco === 2} placeholder="Digite o nome do municipio" type="text" {...formikFisco.getFieldProps('municipio')} className={clsx(
                                    'form-control',
                                    {
                                        'is-invalid': formikFisco.touched.municipio && formikFisco.errors.municipio
                                    },
                                    {
                                        'is-valid': formikFisco.touched.municipio && !formikFisco.errors.municipio
                                    }
                                    )} id="form-fisco-municipio" />
                            </div>
                            
                            <div className="col-md-12">
                                <label className="form-label col-md-1"></label>
                                <label className="form-label col-md-6 titulo-modal">Lista de Calendários</label>
                                <label className="form-label col-md-4 titulo-modal">Calendários Adicionados</label>
                                <DualListBox options={options} selected={selected} onChange={onChange} />
                            </div>
                        </div>
                    :
                        <div className="row g-3">
                            <div className="col-md-2">
                                <label htmlFor="form-fisco-tipoEvento" className="form-label required mt-5">Tipo Evento</label>
                                <select disabled={!carregadoGruposEvento || !carregadoEventos} id="form-fisco-tipoEvento" value={grupoEventoSelecionado}
                                    onChange={async e => {
                                        const grupoEventoId = parseInt(e.target.value);

                                        setGrupoEventoSelecionado(grupoEventoId);
                                        setEventosFiltrados(grupoEventoId === 0 ? eventos : eventos.filter(x => x.grupoEventoID === grupoEventoId));
                                    }} className="form-select">

                                        <option value="" hidden>{ carregadoGruposEvento ? carregadoEventos ? 'Selecione' : 'Aguarde' : 'Carregando' }</option>
                                        {
                                            grupoEvento.length > 0 && grupoEvento.map((x, index) => <option key={index} value={x.id}>{x.nome}</option>)
                                        }
                                </select>
                            </div>
                            <div className="col-md-2">
                                <label htmlFor="form-fisco-evento" className="form-label required mt-5">Evento</label>
                                <select disabled={!carregadoEventos} id="form-fisco-evento" {...formikFiscoEvento.getFieldProps('eventoID')}
                                    onChange={async e => {
                                        const eventoId  = parseInt(e.target.value)
                                        const evento = eventosFiltrados.find(x => x.id === eventoId);

                                        if (evento) {
                                            await formikFiscoEvento.setFieldValue('eventoID', eventoId);
                                            await formikFiscoEvento.setFieldValue('evento', evento);
                                        }
                                    }} className="form-select">

                                    <option value="" hidden>{ carregadoEventos ? carregadoGruposEvento ? 'Selecione' : 'Aguarde' : 'Carregando' }</option>
                                    {
                                        eventosFiltrados.length > 0 && eventosFiltrados.sort((a, b) => a.nome > b.nome ? 1 : -1).map((x, index) => <option key={index} value={x.id}>{x.nome}</option>)
                                    }
                                </select>
                            </div>
                            <div className="col-md-2">
                                <label htmlFor="form-fisco-vencimento" className="form-label required mt-5">Vencimento</label>
                                <select id="form-fisco-vencimento"
                                    {...formikFiscoEvento.getFieldProps('vencimento')}
                                    onChange={ async e => await formikFiscoEvento.setFieldValue('vencimento', parseInt(e.target.value))} className="form-select">
                                        
                                        <option value="" hidden>Selecione</option>
                                        {
                                            vencimento.length > 0 && vencimento.map((x, index) => <option key={index} value={x}>{x}</option>)
                                        }
                                </select>
                            </div>                            
                            <div className="col-md-1">
                                <label htmlFor="form-fisco-aliquota" className="form-label required mt-5">Alíquota</label>
                                <input placeholder="0,0%" type="number" step="0.01" {...formikFiscoEvento.getFieldProps('aliquota')} onChange={async e => await formikFiscoEvento.setFieldValue('aliquota', parseFloat(e.target.value))} className="form-control" id="form-fisco-aliquota" />
                            </div>
                            <div className="col-md-3">
                                <label className="form-label required mt-5">Regra do Tributo</label>
                                <div className="mt-4">
                                    <input className="form-check-input" type="radio" name="regraTributo" value="1" checked={formikFiscoEvento.values.tipoRegraTributoID === 1} onChange={async e => await formikFiscoEvento.setFieldValue('tipoRegraTributoID', parseInt(e.target.value))} id="form-fisco-regratributo-1" />
                                    <label className="form-check-label col-md-5" htmlFor="form-fisco-regratributo-1">
                                        Próximo dia útil
                                    </label>
                                    <input className="form-check-input" type="radio" name="regraTributo" value="2" checked={formikFiscoEvento.values.tipoRegraTributoID === 2} onChange={async e => await formikFiscoEvento.setFieldValue('tipoRegraTributoID', parseInt(e.target.value))} id="form-fisco-regratributo-2" />
                                    <label className="form-check-label" htmlFor="form-fisco-regratributo-2">
                                        Dia útil anterior
                                    </label>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <label className="form-label"></label>
                                <div className="mt-4">
                                    <button className='btn btn-sm btn-primario mt-5' disabled={formikFiscoEvento.isSubmitting || !formikFiscoEvento.isValid} onClick={() => formikFiscoEvento.submitForm()} type="button">
                                        <i className="icon-sm text-white fas fa-plus"/>
                                    </button>
                                </div>
                            </div>
                            <div>
                                <FiscoEventoTabela colunas={columns} itens={fiscoEventos}/>
                            </div>
                        </div>
                }
            </div>
            <div className="modal-footer" style={{ margin: '0 auto' }}>
                <button disabled={formikFisco.isSubmitting} onClick={() => toggleModal()} type="button" className="btn btn-modal-cancelar me-5"> CANCELAR </button>
                <button disabled={formikFisco.isSubmitting || !formikFisco.isValid} onClick={() => formikFisco.submitForm()} type="button" className="btn btn-primario ms-5">
                    {
                        !formikFisco.isSubmitting && (fisco?.id ? 'EDITAR' : 'ADICIONAR')
                    }
                    {
                        formikFisco.isSubmitting && 
                            <span className='indicator-progress' style={{ display: 'block' }}>
                                Salvando...
                                <span className='spinner-border spinner-border-sm align-middle ms-2'/>
                            </span>
                    }
                </button>
            </div>
        </div>
    </Modal>
}

export default FiscoModal;